export default __webpack_public_path__ + "static/media/welcome.111e8292.png";